<template>
  <transition name="modal-fade">
    <div @click.self="close"  class="modal-backdrop" >
      <div class="modal"
           role="dialog"
           aria-labelledby="modalTitle"
           aria-describedby="modalDescription">
        <div class="modal-container" id="modalContainer">
          <div @click="close" class="wrap-back-button">
            <span>
              Close
            </span>
          </div>
          <div class="title" name="title">
            <p v-if="Film.title_en"><span class="modal-title">{{Film.title_en.replaceAll('\\', '')}} </span></p>
            <p><span class="modal-title" v-if="Film.title_de && Film.title_en">{{ `(${Film.title_de.replaceAll('\\', '')})`}}</span><span class="modal-title" v-else>{{ `${Film.title_de.replaceAll('\\', '')}`}}</span></p>
          </div>
          <div class="wrap-image">
            <img v-if="Film.identifier.length > 0" class="card-img" v-lazyload
                 :src="'https://d205.spaceweb.de/fileadmin' + Film.identifier" @error="item.identifier = ''" alt="Image not found">
            <img v-else class="card-img" :src="this.$store.state.dummyPicture" alt="Image not found">
            <div class="description" v-html="Film.eng_film_synopsis.replaceAll('\\', '')" name="title">
            </div>
          </div>

          <div class="modal-content">

            <div class="wrap-details">

              <div class="wrap-wide">
                <p v-if="Film.genre.length > 0"><span class="strong">Genre: </span> <span class="detail-value" v-html="Film.genre.join(', ')"/></p>
                <p v-if="Film.category.length > 0"><span class="strong">Category: </span> <span class="detail-value" v-html="Film.category.join(', ')"/></p>
                <p v-if="Film.year_production" class="space-top"><span class="strong">Production Year: </span> <span class="detail-value" v-html="Film.year_production"/></p>
                <p v-if="Film.film_length_minutes"><span class="strong">Film Duration: </span> <span class="detail-value" v-html="`${Film.film_length_minutes} min`"/></p>
                <p v-if="Film.original_version" class="space-bottom"><span class="strong">Language: </span> <span class="detail-value" v-html="Film.original_version.replaceAll('/', ', ')"/></p>
                <p v-if="Film.screenplay.length > 0">
                  <span class="strong">Screenplay:</span>
                  <span class="detail-value">
                  <span v-for="item in Film.screenplay" :key="item">
                    <a @click="goToPerson(item.uid)" v-html="item.name"/>
                    <span v-if="Film.screenplay[Film.screenplay.length -1] !== item">,&nbsp;</span>
                  </span>
                </span>
                </p>
                <p v-if="Film.format.length > 0" ><span class="strong">Format: </span> <span class="detail-value" v-html="Film.format.join(', ')"/></p>
                <p v-if="Film.backing_free"><span class="strong">Backing: </span> <span class="detail-value" v-html="Film.backing_free"/></p>
                <p v-if="Film.director.length > 0">
                  <span class="strong">Director:</span>
                  <span class="detail-value">
                  <span v-for="item in Film.director" :key="item">
                    <a @click="goToPerson(item.uid)" v-html="item.name"/>
                    <span v-if="Film.director[Film.director.length -1] !== item">,&nbsp;</span>
                  </span>
                </span>
                </p>
                <p v-if="Film.cinematographer.length > 0">
                  <span class="strong">Cinematography:</span>
                  <span class="detail-value">
                  <span v-for="item in Film.cinematographer" :key="item">
                    <a @click="goToPerson(item.uid)" v-html="item.name"/>
                    <span v-if="Film.cinematographer[Film.cinematographer.length -1] !== item">,&nbsp;</span>
                  </span>
                </span>
                </p>
                <p v-if="Film.producer.length > 0">
                  <span class="strong">Producers:</span>
                  <span class="detail-value">
                  <span v-for="item in Film.producer" :key="item">
                    <a @click="goToPerson(item.uid)" v-html="item.name"/>
                    <span v-if="Film.producer[Film.producer.length -1] !== item">,&nbsp;</span>
                  </span>
                  <span v-if="Film.coProducer.length > 0">
                    In Coproduction with
                    <span v-for="item in Film.coProducer" :key="item">
                      <a @click="goToPerson(item.uid)" v-html="item.name"/>
                      <span v-if="Film.coProducer[Film.coProducer.length -1] !== item">,&nbsp;</span>
                    </span>
                  </span>
                </span>
                </p>
                <p v-if="Film.sound.length > 0"><span class="strong">Sound: </span> <span class="detail-value" v-html="Film.sound.join(', ')"></span></p>
                <p v-if="Film.dubbed_version.length > 0"><span class="strong">Dubbed Versions: </span> <span class="detail-value" v-html="Film.dubbed_version"></span></p>
                <p v-if="Film.kino_ausgabe.length > 0"><span class="strong">Cinema version: </span> <span class="detail-value" v-html="`${new Date(Film.kino_ausgabe).getUTCDate()}.${new Date(Film.kino_ausgabe).getMonth()}.${new Date(Film.kino_ausgabe).getUTCFullYear()}`"></span></p>
                <p v-if="Film.shooting"><span class="strong">Shooting: </span> <span class="detail-value" v-html="Film.shooting"></span></p>
                <p v-if="Film.animation.length > 0">
                  <span class="strong">Animation:</span>
                  <span class="detail-value">
                  <span v-for="item in Film.animation" :key="item">
                    <a @click="goToPerson(item.uid)" v-html="item.name"/>
                    <span v-if="Film.animation[Film.animation.length -1] !== item">,&nbsp;</span>
                  </span>
                </span>
                </p>
                <p v-if="Film.voices.length > 0">
                  <span class="strong">Voices:</span>
                  <span class="detail-value">
                  <span v-for="item in Film.voices" :key="item">
                    <a @click="goToPerson(item.uid)" v-html="item.name"/>
                    <span v-if="Film.voices[Film.voices.length -1] !== item">,&nbsp;</span>
                  </span>
                </span>
                </p>
                <p v-if="Film.executiveProducer.length > 0">
                  <span class="strong">Executive Producer:</span>
                  <span class="detail-value">
                  <span v-for="item in Film.executiveProducer" :key="item">
                    <a @click="goToPerson(item.uid)" v-html="item.name"/>
                    <span v-if="Film.executiveProducer[Film.executiveProducer.length -1] !== item">,&nbsp;</span>
                  </span>
                </span>
                </p>
                <p v-if="Film.germanDistributor.length > 0">
                  <span class="strong">German Distributor:</span>
                  <span class="detail-value">
                  <span v-for="item in Film.germanDistributor" :key="item">
                    <a @click="goToCompany(item.uid)" v-html="item.title"/>
                    <span v-if="Film.germanDistributor[Film.germanDistributor.length -1] !== item">,&nbsp;</span>
                  </span>
                </span>
                </p>
                <p v-if="Film.cast.length > 0"  >
                  <span class="strong">Cast: </span>
                  <span class="detail-value">
                    <span v-for="item in Film.cast" :key="item">
                      <a @click="goToPerson(item.uid)" v-html="item.name"/>
                      <span v-if="Film.cast[Film.cast.length -1] !== item">,&nbsp;</span>
                    </span>
                  </span>
                </p>
                <p v-if="Film.prodCompany.length > 0" >
                  <span class="strong">Production company: </span>
                  <span class="detail-value">
                    <span v-for="item in Film.prodCompany" :key="item">
                      <a @click="goToCompany(item.uid)" v-html="item.title"/>
                      <span v-if="Film.prodCompany[Film.prodCompany.length -1] !== item">,&nbsp;</span>
                    </span>
                    <span v-if="Film.coProdCompany.length > 0">
                      In Coproduction with
                      <span v-for="item in Film.coProdCompany" :key="item">
                        <a @click="goToCompany(item.uid)" v-html="item.title"/>
                        <span v-if="Film.coProdCompany[Film.coProdCompany.length -1] !== item">,&nbsp;</span>
                      </span>
                    </span>
                    <span v-if="Film.cooperationCompany.length > 0">
                      In Cooperation with
                      <span v-for="item in Film.cooperationCompany" :key="item">
                        <a @click="goToCompany(item.uid)" v-html="item.title"/>
                        <span v-if="Film.cooperationCompany[Film.cooperationCompany.length -1] !== item">,&nbsp;</span>
                      </span>
                    </span>
                    <span v-if="Film.associationCompany.length > 0">
                      In Association with
                      <span v-for="item in Film.associationCompany" :key="item">
                        <a @click="goToCompany(item.uid)" v-html="item.title"/>
                        <span v-if="Film.associationCompany[Film.associationCompany.length -1] !== item">,&nbsp;</span>
                      </span>
                    </span>
                    <span v-if="Film.for.title">for<a @click="goToCompany(Film.for.uid)"> &nbsp;{{ Film.for.title }} </a></span>
                  </span>
                </p>
                <p v-if="Film.festival" class="space-top"><span class="strong">Festivals: </span> <span class="detail-value" v-html="Film.festival"></span></p>
                <p v-if="Film.international_awards" ><span class="strong">Awards: </span> <span class="detail-value" v-html="Film.international_awards"/></p>
                <div v-if="Film.worldSales.title" class="space-top">
                  <p v-if="Film.worldSales.title">
                    <span class="strong">WorldSales: </span>
                    <ul class="list detail-value">
                      <li v-if="Film.worldSales.title"><span class="detail-value"><a @click="goToCompany(Film.worldSales.uid)" v-html="Film.worldSales.title.toString()"/></span></li>
                      <li v-if="Film.worldSales.person"><span class="detail-value" v-html="Film.worldSales.person.toString()"></span></li>
                      <li v-if="Film.worldSales.address"><span class="detail-value" v-html="Film.worldSales.address.toString()"></span></li>
                      <li v-if="Film.worldSales.phone"><a :href="`tel:${Film.worldSales.phone.toString()}`" class="detail-value" v-html="Film.worldSales.phone.toString()"></a></li>
                      <li v-if="Film.worldSales.email"><a :href="`mailto:${Film.worldSales.email.toString()}`" class="detail-value" v-html="Film.worldSales.email.toString()"></a></li>
                      <li v-if="Film.worldSales.www"><a :href="Film.worldSales.www.toString()" class="detail-value" v-html="Film.worldSales.www.toString()"></a></li>
                    </ul>
                  </p>
                </div>
                <div v-if="Film.contact.name">
                  <p v-if="Film.contact.name"><span class="strong">Contact: </span></p>
                  <ul class="list">
                    <li v-if="Film.contact.name"><span class="detail-value"><a @click="goToCompany(Film.contact.uid)" v-html="Film.contact.title.toString()"/></span></li>
                    <li v-if="Film.contact.person"><span class="detail-value" v-html="Film.contact.person.toString()"></span></li>
                    <li v-if="Film.contact.address"><span class="detail-value" v-html="Film.contact.address.toString()"></span></li>
                    <li v-if="Film.contact.phone"><a :href="`tel:${Film.contact.phone.toString()}`" class="detail-value" v-html="Film.contact.phone.toString()"></a></li>
                    <li v-if="Film.contact.email"><a :href="`mailto:${Film.contact.email.toString()}`" class="detail-value" v-html="Film.contact.email.toString()"></a></li>
                    <li v-if="Film.contact.www"><a :href="Film.contact.www.toString()" class="detail-value" v-html="Film.contact.www.toString()"></a></li>
                  </ul>
                </div>
                <div v-if="Film.contactPerson.length > 0">
                  <p v-if="Film.contactPerson.length > 0"><span class="strong">Contact Person: </span></p>
                  <ul class="list">
                    <li v-if="Film.contactPerson"><a @click="goToPerson(Film.contactPerson.uid)" v-html="Film.contactPerson.toString()"></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div @click="close" class="wrap-back-button">
            <span>
              Close
            </span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import LazyLoadDirective from '../../directives/LazyLoadDirective';

export default {
  directives: {
    lazyload: LazyLoadDirective,
  },
  data() {
    return {
      Film: this.$store.state.wholeDatabase.filter((Film) => Film.uid === this.$store.state.selectedFilmCard)[0],
    };
  },
  name: 'Modal',
  methods: {
    async goToPerson(id) {
      // Wird ausgeführt wenn man auf eine Person klickt -> Person.vue wird angezeigt
      await this.$store.commit('updateSelectedPersonCard', id);
      this.$router.push({ path: this.$store.state.site, query: { person: id } });
    },
    async goToCompany(id) {
      // Wird ausgeführt wenn man auf eine Firma klickt -> company.vue wird angezeigt
      await this.$store.commit('updateSelectedCompanyCard', id);
      this.$router.push({ path: this.$store.state.site, query: { company: id } });
    },
    close() {
      // Schließt das Modal
      const { vueURL } = this.$store.state;
      this.$store.commit('updateSelectedFilmCard', 0);
      this.$router.push({ path: this.$store.state.site, query: vueURL });
    },
  },

};
</script>
<style>
.space-top{
  margin-top: 2rem !important;
}
.space-bottom{
  margin-bottom: 2rem !important;
}
.wrap-back-button span{
  transition: margin-right .2s;
  margin-right: 10px;
}

.wrap-back-button:hover span{
  margin-right: 0;
}

.modal-container a:hover{
  cursor: pointer;
  text-decoration: underline !important;
  color: #ff0000 !important;
}
.list {
  list-style: none;
}
.wrap-wide{
  width: 100%;
  margin: 0.5rem 0;
}

.modal-title{
  font-size: 1.5rem;
  font-weight: bold;
}
</style>
